(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bshop-footer"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initFooter(scope) {
    var footer = scope.querySelector('.bshop-footer');
    if (!footer || footer.dataset.menusReady === 'true') return;
    footer.dataset.menusReady = 'true';
    var query = window.matchMedia('(max-width: 780px)');
    var menus = footer.querySelectorAll('.bf-menu');
    function updateLayout() { menus.forEach(function (menu) { menu.open = !query.matches; }); }
    menus.forEach(function (menu) {
      menu.querySelector('summary').addEventListener('click', function (event) { if (!query.matches) event.preventDefault(); });
    });
    updateLayout();
    if (query.addEventListener) query.addEventListener('change', updateLayout);
    else query.addListener(updateLayout);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initFooter(document); });
  else initFooter(document);
  document.addEventListener('shopify:section:load', function (event) { initFooter(event.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    theme.settings.cartType !== 'page' && event.preventDefault();
  });

  document.addEventListener('product-form:submit:success', () => {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
  });

  } catch(e) { console.error(e); }
})();
})();
